
import { DollarSign, Info, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LenderActionsProps {
  lenderId: string;
  view?: "grid" | "list";
}

export const LenderActions = ({ lenderId, view = "grid" }: LenderActionsProps) => {
  return (
    <div className={cn(
      "flex gap-2",
      view === "grid" ? "flex-col" : "flex-row"
    )}>
      <Button className="w-full" asChild>
        <Link to={`/pre-approval?lender=${lenderId}`}>
          <ShieldCheck className="h-4 w-4 mr-2" />
          Get Pre-Approved
        </Link>
      </Button>
      <Button variant="outline" className="w-full" asChild>
        <Link to={`/lender/${lenderId}`}>
          <Info className="h-4 w-4 mr-2" />
          View Details
        </Link>
      </Button>
    </div>
  );
};
